<p-dialog [draggable]="false" [resizable]="false" [(visible)]="visible"
    [style]="{ width: '330px' }" (onHide)="handleHide()">
    <div class="text-center fm-prompt">
        <div class="text-black mb-1" style="font-size: 1.2rem; font-weight: 500;">
            Forgot Password
        </div>
        <div class="fm-rubik mb-2" style="font-size: 0.85rem;font-weight: 400;">
            Fill your email to continue
        </div>
        <div class="mt-1 p-2 fm-rubik" style="text-align: left;">
            <span style="font-size: 0.8rem;color: #848790;font-weight: 500;">Email</span>
            <input type="email" class="p-2 w-100 input-promo" style="font-size: 0.9rem;font-weight: bold;"
                placeholder="Name@example.com" [(ngModel)]="forgotEmail" />
        </div>
        <div class="mt-1 p-2" style="text-align: center;">
            <button [disabled]="forgotEmail==''" [style.background-color]="forgotEmail!='' ?  '#EF870A' : '#b4b4bb'"
                class="btn w-100 fm-prompt fw-bold"
                style="color: white;background-color: #EF870A;font-size: 1.143rem;border-radius: 12px;padding-top: 0.5rem;padding-bottom: 0.5rem;"
                (click)="requestChangePassword()">Recover password</button>
        </div>
        <div class="my-1 p-2 fm-rubik" style="text-align: center;">
            <span style="font-size: 0.857rem;font-weight: 400;color: #5D5D66;">
                Return to login
            </span>
            <span class="fm-prompt" style="color: #EF870A;font-size: 1rem;font-weight: bold;cursor: pointer;"
                (click)="handleHide()">Sign in</span>
        </div>
    </div>
</p-dialog>
